import AutomationOptionChatClosed from './chatClosed'

export default {
    AutomationOptionChatClosed
}
